import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import LogoSvg from '-!svg-react-loader!../../svg/logo.svg';

import './index.css';

const Logo = ({ className }) => <LogoSvg className={cn('logo', className)} />;

Logo.propTypes = {
  className: PropTypes.string,
};

export default Logo;



// WEBPACK FOOTER //
// ./src/common/components/Logo/index.js